import React from 'react';
import intl from "react-intl-universal";
import {useRootStore, useDsManager, useAppState} from "@stores/AppStateContext";
import {useCrudServices} from "../../../platform/hooks/useServiceCombinations";

import {handleCreateCluster, handleCreateItem} from "../../../actions/utils/handleCreateItem";
import {ItemModelType} from "../../../stores/WorkspaceStore";


import {Button} from "../../components/Button";
import {AddIcon} from "../../components/icons/AddIcon";
import {AddClusterIcon} from "../../components/icons/AddClusterIcon";


import './ClusterEmpty.css';


export interface ClusterEmptyProps {
    item: ItemModelType;
}

export const ClusterEmpty = ({item}: ClusterEmptyProps) => {
    const appState = useAppState();
    const rootStore = appState.rootStore;
    const crudServices = useCrudServices();
    const workspace = rootStore.view.workspace!;

    return (
        <div className='ClusterEmpty'>
            <div className="ClusterEmpty__content">
                <div
                    className="ClusterEmpty__header title-medium-bold">{intl.get('cluster_empty.header').d('No pages or clusters.')}</div>
                <div
                    className="ClusterEmpty__message body-large">{intl.get('cluster_empty.message').d('You can create something right now:')}</div>
                <div className="ClusterEmpty__btns">
                    <Button
                        className={'ClusterEmpty_btn'}
                        type="neutral"
                        size="md"
                        style="plain"
                        htmlType="submit"
                        Icon={AddIcon}
                        text={intl.get('cluster-view.new_item').d('Create page')}
                        onClick={handleCreateItem(crudServices, workspace, appState, item)}
                    />
                    <Button
                        className={'ClusterEmpty_btn'}
                        type="neutral"
                        size="md"
                        style="plain"
                        htmlType="submit"
                        Icon={AddClusterIcon}
                        text={intl.get('cluster-view.new_cluster').d('Create cluster')}
                        onClick={handleCreateCluster(crudServices, workspace, appState, item)}
                    />
                </div>
            </div>
        </div>
    )
}
